// PIP / no-fault states — frontend mirror of server/src/config/pipStates.js.
//
// Orgs based in any of these states are billed for MediLink Pro at the higher
// per-location rate. This module is for DISPLAY ONLY (signup review, subscribe
// page, add-location confirm). The backend is the source of truth for what is
// actually charged. Keep the state list in sync with the server copy.
export const PIP_STATES = new Set([
  'FL', 'HI', 'KS', 'MA', 'MI', 'MN', 'NJ', 'NY', 'ND', 'UT', 'DE', 'OR',
]);

// Per-location monthly price in whole dollars. Mirrors the Stripe prices
// (STRIPE_PRICE_ID_PRO = $1,000, STRIPE_PRICE_ID_PIP = $2,500).
export const STANDARD_PRICE_PER_LOCATION = 1000;
export const PIP_PRICE_PER_LOCATION = 2500;

// Provider types a medical_practice picks at signup. Keep in sync with the
// server copy in server/src/config/pipStates.js and migration 032.
export const PROVIDER_TYPES = [
  { value: 'ortho',          label: 'Orthopedics' },
  { value: 'surgery_center', label: 'Surgery Center' },
  { value: 'hospital',       label: 'Hospital' },
  { value: 'mri_imaging',    label: 'MRI / Imaging Center' },
  { value: 'plastic_surgery', label: 'Plastic & Reconstructive Surgery' },
  { value: 'chiropractic',   label: 'Chiropractic' },
  { value: 'other',          label: 'Other' },
];

const DEMO_FLAT_PRICING = process.env.REACT_APP_DEMO === 'true';

export function isPipState(state) {
  if (!state) return false;
  return PIP_STATES.has(String(state).trim().toUpperCase());
}

// Whole-dollar per-location price. Pricing rule (2026-10-30): the state
// decides — PIP / no-fault states bill premium ($2,500), every other state
// bills standard ($1,000), whatever the provider type. Same as the server's
// priceIdFor(); providerType is accepted for call-site compatibility only.
export function pricePerLocation(state, providerType) {
  // The demo environment bills a single flat rate for every location so a
  // walkthrough never has to explain the PIP-state difference mid-pitch.
  // Mirrors DEMO_MODE in server/src/config/pipStates.js, which picks the
  // matching Stripe price — keep the two in step or the demo would quote one
  // number and charge another at checkout.
  if (DEMO_FLAT_PRICING) return PIP_PRICE_PER_LOCATION;
  return isPipState(state) ? PIP_PRICE_PER_LOCATION : STANDARD_PRICE_PER_LOCATION;
}

// Formatted price string, e.g. "$2,500".
export function formatPricePerLocation(state, providerType) {
  return `$${pricePerLocation(state, providerType).toLocaleString()}`;
}
